<template>
  <div v-if="activities" >
    <header class="page-sub-heading">
      <h1 class="ut-font-bold">Assist calls</h1>
      <ul class="date-filter">
        <li v-for="df in dateFilters" :key="df.value" :class="{'active': activeDateFilter == df.value}" @click="setActive(df)">{{df.label}}</li>
      </ul>
    </header>
    <div class="ut-flex cards-summary md: ut-justify-between ut-items-start">
        <prospect-activity-card
            :value="totalAssistCalls"
            :title="'Assistant calls'"/>
        <prospect-activity-card
            :value="totalConversations"
            :title="'Conversations'"/>
        <prospect-activity-card
            :value="totalProspects"
            :title="'Prospects'"/>
        <prospect-activity-card
            :value="lastCallDate"
            :title="lastCallContent"
            :styleClass="'oa-green-bg-color'" />
    </div>
    <div>
      <header class="page-sub-heading">
        <h1>Highlights</h1>
      </header>
      <ul class="highlight-list">
        <li>
          <span class="count green-highlight">{{totalProspects}}</span>
          <span class="content-text ut-py-2">
            <p>Prospects</p>Serious sellers that we've passed over
            <!-- <i class="right-arrow-shape"></i> -->
          </span>
        </li>
        <li>
          <span class="count medium-highlight">{{totalFutureCheckin}}</span>
          <span class="content-text ut-py-0 md:ut-py-2">
            <p>Another call scheduled</p>Keeping warm for you - planning to sell in 6-12 months
            <!-- <i class="right-arrow-shape"></i> -->
          </span>
        </li>
        <li>
          <span class="count dark-highlight">{{totalOnMarket}}</span>
          <span class="content-text ut-py-2">
            <p>Currently on market</p>Check back in 60 days to see if they've sold
            <!-- <i class="right-arrow-shape"></i> -->
          </span>
        </li>
      </ul>
    </div>
    <div class="ut-mb-8">
      <header class="page-sub-heading">
        <h1>Recent Conversations</h1>
      </header>
      <div class="md:ut-justify-between ut-items-start">
        <prospecting-activity-card-details :listIcon="'icon-chat'" :textContent="textContent(a)" :noteContent="noteContent(a)" :activityDate="formatDate(a.activityDate, 'D MMM, YYYY H:mm')" :showExtraInfo="showExtraInfo(a)" :extraInfo="extraInfo(a)" v-for="(a, index) in recentConversations" :key="index" />
        <load-more
          v-if="showLoadMore"
          @click.native="fetchMoreConversation()"
          :active="isLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ProspectActivityCard from '@/components/Prospecting/ProspectingDashboard/ProspectActivityCard.vue';
import ProspectingActivityCardDetails from '@/components/Prospecting/ProspectingDashboard/ProspectingActivityCardDetails.vue';
import { ProspectActivityActionTypeId } from '@/Mapper/ProspectActivityActionType';
import ProspectStageType from '@/Mapper/ProspectStageType';
import LoadMore from '@/components/loading/LoadMore.vue';

export default {
  name: 'ProspectingAssistant',
  components: {
    ProspectActivityCard,
    ProspectingActivityCardDetails,
    LoadMore
  },
  props: {
    activities: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      gacategory: 'Prospecting Tool Agent portal',
      dateFilters: [
        {value: 1, label: '1M'}, 
        {value: 3, label: '3M'}, 
        {value: 0, label: 'ALL'}
      ],
      activeDateFilter: 0,
      pageSize: 10,
      pageNum: 1,
      isLoading: false,
      hideLoadMore: false,
      filteredResults: [],
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    showLoadMore() {
      return !this.hideLoadMore
        && this.pageSize*this.pageNum < this.filteredResults.length;
    },
    lastCallContent() {
      if(this.activities.lastCallSession && this.activities.lastCallSession.rawMetaData && this.$helpers.strHasValue(this.activities.lastCallSession.rawMetaData.consultantName)){
        return `Last call session by ${this.activities.lastCallSession.rawMetaData.consultantName.split(" ")[0]} your Assistant`
      }
      return `Last call session by your Assistant`;
    },
    lastCallDate() {
      return this.activities.lastCallSession? this.formatDate(this.activities.lastCallSession.activityDate, "Do MMM") : "N/A";
    },
    totalAssistCalls() {
      if(this.activeDateFilter == 0) {
        return this.activities.totalAssistantCalls.toString();
      }
      const results = this.activities.Activities.filter(a => 
        [ProspectActivityActionTypeId.CallAttempt, ProspectActivityActionTypeId.CallContact, ProspectActivityActionTypeId.CallSuccess].indexOf(a.actionType.activityActionTypeId) > -1
        && this.activityInDateRange(a.activityDate)); 
        return results.length.toString();
    },
    totalConversations() {
      if(this.activeDateFilter == 0) {
        return this.activities.totalConversations.toString();
      }
      const results = this.activities.Activities.filter(a => 
        [ProspectActivityActionTypeId.CallContact, ProspectActivityActionTypeId.CallSuccess].indexOf(a.actionType.activityActionTypeId) > -1
        && this.activityInDateRange(a.activityDate)); 
        return results.length.toString();
    },
    totalProspects() {
      if(this.activeDateFilter == 0) {
        return this.activities.totalProspects.toString();
      }
      return this.getProspects().length.toString();
    },
    totalFutureCheckin() {
      return this.getFollowup().length;
    },
    totalOnMarket() {
      return this.getCurrentOnMarket().length;
    },
    recentConversations() {
      return this.getRecentConversationActivities();
    },
  },
  created() {},
  methods: {
    ...mapActions('prospectsStore', [
      'loadAgentCallActivities',
    ]),
    formatDate(date, format) {
      return this.$helpers.convertFromUTC(date, format);
    },
    setActive(dateFilter) {
      this.activeDateFilter = dateFilter.value;
    },
    activityInDateRange(activityDate) {
      if(!activityDate)
        return false;
      //format listed date
      activityDate = this.$helpers.convertFromUTC(activityDate);
      return this.activeDateFilter == 0? true : this.$helpers.isSameOrAfter(activityDate, this.$helpers.getPreviousDate(new Date(), this.activeDateFilter, "months"), "day");
    },
    getProspects() {
      //get all prospects activity
      const results = this.activities.Activities.filter(a => a.prospectStageTypeId == ProspectStageType.new);
      //filter unique prospects by prospect key
      const uniqueResults = this.$helpers.arrayGroupBy(results, r => r.prospectKey);
      console.log(uniqueResults.filter(a => this.activityInDateRange(a.activityDate)));
      return uniqueResults.filter(a => this.activityInDateRange(a.activityDate));
    },
    getFollowup() {
      return this.activities.Activities.filter(a => 
        a.actionType.activityActionTypeId == ProspectActivityActionTypeId.OAProspect && a.rawMetaData && 
        a.rawMetaData.requiresOpenAgentFollowUp == "OpenAgent future check in" && 
        this.activityInDateRange(a.activityDate)); 
    },
    getCurrentOnMarket() {
      return this.activities.Activities.filter(a => 
        a.actionType.activityActionTypeId == ProspectActivityActionTypeId.OAProspect && a.rawMetaData && a.rawMetaData.currentSituation && 
        a.rawMetaData.currentSituation.includes("currently on the market")
        && this.activityInDateRange(a.activityDate)); 
    },
    getRecentConversationActivities() {
        //get all PA Prospect activities(consultant submitted assist form where activity date falls into date range filter)
        const OAAData = this.activities.Activities.filter(a => a.actionType.activityActionTypeId == ProspectActivityActionTypeId.OAProspect && this.activityInDateRange(a.activityDate)); 
        let results = [];
        for(var a of OAAData) {
            //check if prospect has been sent
            if(a.prospectChilliScore == 500 ) {
                a.tag = "prospect";
                results.push(a);
            } else if(a.rawMetaData && a.rawMetaData.requiresOpenAgentFollowUp == "OpenAgent future check in" ) {
                //check follow up status
                a.tag = "followup";
                results.push(a);
            } else if (a.rawMetaData && a.rawMetaData.currentSituation &&
                (a.rawMetaData.currentSituation.includes("currently on the market") 
                || a.rawMetaData.currentSituation.includes("selling")
                || a.rawMetaData.currentSituation.includes("recently sold"))
                ) {
                //check selling situation
                a.tag = "sellingsituation";
                results.push(a);
            }
        }
        //sort activities by most recent
        results = results.sort((a, b) => new Date(b.activityDate) - new Date(a.activityDate));

        //filter unique prospects by prospect key
        const uniqueResults = this.$helpers.arrayGroupBy(results, r => r.prospectKey);
        console.log(uniqueResults);
        this.filteredResults = uniqueResults;
        return uniqueResults.slice(0, this.pageNum*this.pageSize);
    },
    mapActivityAction(activity) {
      if(activity.tag == "prospect") {
        return "has been sent to you as a selling prospect";
      } else if (activity.tag == "followup") {
        return `has been put on a follow-up path; we’ll call them back${!activity.rawMetaData.requestcallbackTimeframe? "." : " in "+ activity.rawMetaData.requestcallbackTimeframe}`;
      } else if(activity.tag == "sellingsituation") {
         if(activity.rawMetaData.currentSituation && activity.rawMetaData.currentSituation.includes("selling")) {
             return "is selling soon";
         } 
         if(activity.rawMetaData.currentSituation && activity.rawMetaData.currentSituation.includes("recently sold")) {
             return "has recently sold";
         } 
         if(activity.rawMetaData.currentSituation && activity.rawMetaData.currentSituation.includes("currently on the market")) {
             return "is currently on the market";
         }
      }
    },
    textContent(activity, type) {
      return `${this.$helpers.emptyPlaceholderWhenNoData(activity.contactFirstName)} ${this.$helpers.emptyPlaceholderWhenNoData(activity.contactLastName)} of <b>${activity.metaData.address}</b> ${this.mapActivityAction(activity, type)}`;
    },
    noteContent(activity) {
      if(this.$helpers.strHasValue(activity.rawMetaData.futurePlan)) {
        return activity.rawMetaData.futurePlan;
      }
      return null;
    },
    showExtraInfo(activity) {
      //check if the property address source type is 5 "OA Assistant" 
      return activity.contactPropertyAddress.source.sourceTypeId == 5;
    },
    extraInfo(activity) {
      return this.showExtraInfo(activity)? "Address added by OpenAgent" : null;
    },
    fetchMoreConversation() {
      this.pageNum++;
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cards-summary {
  margin: 0 -10px;
  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
}

.page-sub-heading {
  @apply ut-flex ut-pb-6 ut-pt-12; 
  
  @screen md {
    @apply ut-pb-6;
  }

  h1 {
    @apply ut-ml-0;
    font-size: 20px;
    letter-spacing: -0.4px;
    line-height: 36px;
    color: #1B1B1B;
  }
}
.date-filter {
  @apply ut-mr-2 ut-ml-auto ut-flex;
  li {
    @apply ut-ml-4;
    color: #ABAAA8;
    font-size: 11px;
    text-decoration: none;
  }
  li:hover {
    cursor: pointer;
  }
  li.active {
    @apply ut-font-bold;
    color: #22B35A;
    text-decoration: underline;  
  }
}

.right-arrow-shape {
  box-sizing: border-box;
  height: 5px;
  width: 5px;
  border-top: 1px solid #25BA68;
  border-right: 1px solid #25BA68;
  transform: rotate(45deg);
  float: right;
}

.highlight-list {
  li {
    @apply ut-flex ut-justify-between ut-items-start;
    .count {
      @apply ut-text-xl ut-font-bold ut-text-neutral-001 ut-m-0;
      height: auto;
      width: 60px; 
      padding: 14px;  
      text-align: center;  
    }
    .green-highlight {
      background: linear-gradient(180deg, #3AAA7C 0%, #25BA68 100%);
    }
    .medium-highlight {
      background: linear-gradient(180deg, #63B9B3 0%, #33837C 100%);
    }
    .dark-highlight {
      background: linear-gradient(180deg, #00605A 0%, #00322E 100%);
    }
    .content-text {
      box-sizing: border-box;
      border-top: 1px solid rgba(151, 151, 151, 0.2);
      height: auto;
      @apply ut-text-xs ut-w-full ut-m-0 ut-px-4;   
      
      p {
        @apply ut-text-sm;
      }
      i {
        float: right;  
      }
    }
  }
  li:last-child {
    .content-text {
      box-sizing: border-box;
      border-top: 1px solid rgba(151, 151, 151, 0.2);
      border-bottom: 1px solid rgba(151, 151, 151, 0.2);
    }
  }
}
</style>
